var _style, _ellipse, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExecutingTransformation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e8UuQMTJNzw1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n        #e8UuQMTJNzw2 {animation: e8UuQMTJNzw2_s_do 1000ms linear 1 normal forwards}@keyframes\r\n        e8UuQMTJNzw2_s_do { 0% {stroke-dashoffset: 56.55} 100% {stroke-dashoffset: 0}}\r\n    ")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "e8UuQMTJNzw2",
    rx: 9,
    ry: 9,
    transform: "matrix(0-1 1 0 12 12)",
    fill: "none",
    stroke: "#2d8825",
    strokeDashoffset: 56.55,
    strokeDasharray: 56.55
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.56,16l6.93-4L9.56,8v8Zm1-6.27L14.49,12l-3.93,2.27v-4.54Z",
    fill: "#2d8825"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExecutingTransformation);
export default __webpack_public_path__ + "static/media/executing-transformation.8b711c5e2e00097fcf5267f5de8fde0d.svg";
export { ForwardRef as ReactComponent };